var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test",staticStyle:{"width":"100%","height":"100%"}},[_c('VEmojiPicker',{on:{"select":_vm.onSelectEmoji}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }